import * as React from 'react';

import { Svg } from 'common/components';
import { IconProps } from 'common/types';

const Speaker = (props: IconProps) => {
  return (
    <Svg viewBox="0 0 18 17" {...props}>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Media"
          transform="translate(-253.000000, -661.000000)"
          stroke="#111111"
          strokeWidth="2"
        >
          <g id="Media_type_audio" transform="translate(20.000000, 520.000000)">
            <g id="sound" transform="translate(234.000000, 142.000000)">
              <polygon
                id="Path"
                points="5.5 4.5 0.5 4.5 0.5 10.5 5.5 10.5 11.5 14.5 11.5 0.5"
              ></polygon>
              <path
                d="M14,3.93 C14.926,4.837 15.5,6.102 15.5,7.5 C15.5,8.863 14.955,10.098 14.07,11"
                id="Path"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </Svg>
  );
};

Speaker.defaultProps = {
  size: '16px',
  color: 'black',
  hoverColor: 'black',
};

export default Speaker;
